import React from "react";
import {useSelector} from "react-redux";
import {selectAuthStatus} from "reducers/auth";
import {selectPortalData} from "reducers/configuration";
import {selectUserAccess, UserAccessFields} from "reducers/client";
import {Spinner} from "./ui/Spinner";
import {PortalFields} from "./LeftMenu/LeftMenuLinks/models";
import NotFound from "./NotFound";
import ErrorBoundary from "./ErrorBoundary";
import ErrorFallback from "./fallbacks/ErrorFallback";
import {Navigate} from "react-router-dom";

const Private: React.FC<{
  children: any;
  userAccessField?: keyof UserAccessFields;
  portalConfigField?: keyof PortalFields;
}> = ({children, userAccessField, portalConfigField}) => {
  const authStatus = useSelector(selectAuthStatus);
  const portalData = useSelector(selectPortalData);
  const userAccess = useSelector(selectUserAccess);

  const content = () => {
    if ((portalConfigField && !portalData) || (userAccessField && !userAccess))
      return <Spinner/>;
    if (portalConfigField && portalData && !portalData[portalConfigField])
      return <NotFound/>;


    if (userAccessField && userAccess && !userAccess[userAccessField]) {
      console.log("User cannot access this page", userAccessField);
      console.log("User cannot access this page", userAccess);

      return <NotFound/>;
    }

    if (authStatus === "signed_out") {
      return <Navigate to={"/sign-in"}/>;
    }

    return children;
  };

  return (
    <ErrorBoundary fallback={<ErrorFallback/>}>{content()}</ErrorBoundary>
  );
};

export default Private;
